import React from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'

import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { selectedSubjectAtom } from './subject.atom'
import { ISubject } from 'components/ingestion/Utility'
import { useSubjectsByName } from '../../../../api/subjects.atoms'

const SubjectSelector = () => {
  const subjects = useSubjectsByName() ?? {}
  const [selectedSubject, setSelectedSubjectAtom] = useAtom(selectedSubjectAtom)

  const updateSubject = (value: number) => {
    const selected = Object.entries(subjects).find(
      ([_, subject]) => subject.subject_id === value,
    )
    if (!selected && !selectedSubject.branches) {
      return
    }
    const branch = selectedSubject.branches.find(
      (branch) => branch.subject_id === value,
    )

    if (branch) {
      setSelectedSubjectAtom({
        subject_id: branch.subject_id,
        subject_name: branch.subject_name,
        branches: [],
      })
      return
    }
    if (!selected) {
      return
    }
    setSelectedSubjectAtom({
      subject_id: selected[1].subject_id,
      subject_name: selected[1].subject_name,
      branches: selected[1].branches,
    })
  }

  //TODO: Add branch selector properly.
  //Note: the current navigation in web does not support most of branch selection
  //so Geometry and Algebra are not visually supported.
  return (
    <Box width={150}>
      <FormControl fullWidth aria-label="subject">
        <InputLabel id="subject-selector-label" htmlFor="subject-selector">
          Subject
        </InputLabel>
        <Select
          onChange={(e) => {
            updateSubject(e.target.value as unknown as number)
          }}
          value={selectedSubject.subject_id}
          id={'subject-selector'}
          label={'Subject'}
          data-testid="subject-selector"
        >
          {Object.entries<ISubject>(subjects).map(([key, subject]) => (
            <MenuItem
              key={`subject-selector-${key}`}
              value={subject.subject_id}
            >
              {subject.subject_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!!selectedSubject?.branches && (
        <FormControl fullWidth>
          <InputLabel id="subject-branch-selector-label">
            Subject Branch
          </InputLabel>
          <Select
            onChange={(e) => {
              updateSubject(e.target.value as unknown as number)
            }}
            value={selectedSubject.subject_id}
            id={'subject-branch-selector'}
            label={'Subject Branch'}
          >
            {selectedSubject.branches.map((subject, index) => (
              <MenuItem
                key={`grade-selector-seled-${subject.subject_name}-${index}`}
                value={subject.subject_id}
              >
                {subject.subject_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  )
}

export default SubjectSelector
